<template>
  <el-card class="box-card cookieBox" v-if="showPopup">
    <div class="cookieNaslov">Politika piškotkov</div>
    <div class="cookieJedro">
      Ta spletna stran uporablja piškotke. Poleg obveznih, uporabljamo tudi piškotke za analizo obiska
      spletnih strani in izboljšanje uporabniške izkušnje. S soglasjem »strinjam se« dovoljujete vse
      namene uporabe. Posamezne namene lahko nastavite <router-link :to="{name: 'Podrobnosti piskotkov'}">tukaj</router-link>.
    </div>
    <div class="cookieDetails" v-if="details">
      <div v-for="(cookie, index) in cookies.list" :key="`cookieItem-${index}`">
        <el-checkbox class="checkbox20" v-model="cookie.value" :disabled="cookie.required">{{cookie.label}}</el-checkbox>
      </div>
      <div>
        <el-button id="cookieBtnShraniZapri" class="cookieBtnShraniInZapri" @click="cookies.shraniPiskotke(); showPopup = false">Shrani in zapri</el-button>
      </div>
    </div>
    <div class="cookieFooter">
      <el-button id="cookieBtnIzberiVse" type="primary" @click="cookies.izberiVse(true); showPopup = false">Izberi vse in zapri obvestilo</el-button>
      <el-button id="cookieBtnIzberiObvezne" class="cookieBtnObvezne" @click="cookies.izberiObvezne(true, true); showPopup = false">Izberi obvezne</el-button>
      <el-button id="cookieBtnNastavitve" class="cookieBtnCustom" @click="details = !details">Nastavitve</el-button>
    </div>
  </el-card>
</template>

<script>
import {Card, Button, Checkbox} from 'element-ui'
import Cookie from 'js-cookie'
import CookiesLogic from '../../assets/js/CookiesLogic'
export default {
  name: 'CookiesPopup',
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox
  },
  data () {
    return {
      showPopup: false,
      details: false,
      cookies: CookiesLogic.getInstance()
    }
  },
  created () {
    this.showPopup = Cookie.get('piskotki') === undefined
  }
}
</script>

<style scoped>
  .cookieBox {
    bottom: 0px;
    right: 0px;
    position: fixed;
    max-width: 550px;
    z-index: 9999999;
    margin: 20px;
  }
  .cookieBox div.cookieNaslov {
    font-size: 16px;
    font-weight: bold;
    padding-top: 0;
    margin: 0 0 0.5em;
    color: black;
  }
  .cookieBox div.cookieJedro {
    font-size: 12px;
    margin: 0;
    line-height: 1.32;
    color: #4a4b4c;
    font-family: proxima-nova,Helvetica,sans-serif;
    font-weight: 400;
  }
  .cookieBox div.cookieJedro a {
    color: black;
    text-decoration: underline;
  }
  .cookieBox button{
    margin-top: 1.2em;
    text-transform: uppercase;
    font-size: 12px;

  }
  .cookieBox .cookieBtnObvezne {
    border-color: #f58220;
  }
  .cookieBox .cookieFooter > .cookieBtnCustom {
    border: 0;
    color: #f58220;
  }
  .cookieDetails {
    padding-top: 10px;
  }
  .cookieBox .cookieBtnShraniInZapri {
    margin-top: 5px;
    border-color: #f58220;
    padding: 6px 10px;
  }
</style>
<style>
.cookieDetails .el-checkbox__label {
  color: #4a4b4c !important;
  font-family: proxima-nova,Helvetica,sans-serif;
  font-weight: 400;
}
.cookieDetails .el-checkbox.is-disabled .el-checkbox__inner::after {
  border-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/CookiesPopup.vue